import type { TemplateStatusInfo, RepublishActionData } from '~/modules/campaign-template';

import { GI18NText } from '~/presentation/common';
import { useTranslation } from 'react-i18next';
import { List, Text } from '@shopify/polaris';
import { ActionTemplate } from './common';

interface UnpublishedTemplateContentProps {
  unpublishedTemplates: TemplateStatusInfo[];
  isBannerInCard?: boolean;
  onRepublish: (data: RepublishActionData) => void;
}

export const UnpublishedTemplateContent = ({
  unpublishedTemplates,
  onRepublish,
  isBannerInCard,
}: UnpublishedTemplateContentProps) => {
  const { t } = useTranslation();

  const getTitle = () => {
    const subtitle = t('Please republish the template to ensure the experiment runs normally:');
    if (isBannerInCard)
      return t('This experiment has unpublished or deleted template. {{subtitle}}', { subtitle });

    return subtitle;
  };

  return (
    <>
      <Text as="p" variant="bodyMd">
        {getTitle()}
      </Text>
      <List gap="extraTight">
        {unpublishedTemplates.map(({ name, variant, campaign }) => {
          return (
            <List.Item key={variant.id}>
              <GI18NText
                as="span"
                variant="bodyMd"
                transformers={{
                  1: (text) => (
                    <Text as="span" fontWeight="semibold" variant="bodyMd">
                      {text}
                    </Text>
                  ),
                }}
              >
                {t('[1]{{name}}[].', { name })}
              </GI18NText>{' '}
              <ActionTemplate
                actionLabel={t('Open page to republish')}
                onHandleAction={() => onRepublish({ campaign, variant })}
              />
            </List.Item>
          );
        })}
      </List>
    </>
  );
};
